import {
  AudioQueueItem,
  AudioQueueState,
} from './project-response-audio-queue.types';

export function enqueueAudio(
  state: AudioQueueState,
  item: AudioQueueItem
): AudioQueueState {
  // Check if item already exists in queue
  const exists = state.queue.some((q) => q.messageId === item.messageId);
  if (exists) {
    return state;
  }

  return {
    ...state,
    queue: [...state.queue, item],
  };
}

export function updateAudioInQueue(
  state: AudioQueueState,
  messageId: string,
  updates: Partial<AudioQueueItem>
): AudioQueueState {
  return {
    ...state,
    queue: state.queue.map((item) =>
      item.messageId === messageId ? { ...item, ...updates } : item
    ),
  };
}

export function setCurrentPlaying(
  state: AudioQueueState,
  messageId: string | null
): AudioQueueState {
  return {
    ...state,
    currentPlayingId: messageId,
    queue: state.queue.map((item) =>
      item.messageId === messageId
        ? { ...item, status: 'playing' as const }
        : item
    ),
  };
}

export function markAudioCompleted(
  state: AudioQueueState,
  messageId: string
): AudioQueueState {
  return {
    ...state,
    queue: state.queue.map((item) =>
      item.messageId === messageId
        ? { ...item, status: 'completed' as const }
        : item
    ),
    currentPlayingId:
      state.currentPlayingId === messageId ? null : state.currentPlayingId,
  };
}

export function getNextAudioInQueue(
  state: AudioQueueState
): AudioQueueItem | null {
  // Find the first audio that is ready to play (not loading, not playing, not completed, not error)
  return (
    state.queue.find(
      (item) => item.status === 'ready' && item.audioUrl !== null
    ) || null
  );
}

export function clearQueue(): AudioQueueState {
  return {
    queue: [],
    currentPlayingId: null,
  };
}

export function isQueueEmpty(state: AudioQueueState): boolean {
  return state.queue.length === 0;
}

export function hasCompletedAll(state: AudioQueueState): boolean {
  if (state.queue.length === 0) return true;
  return state.queue.every((item) => item.status === 'completed');
}
